import * as React from 'react';

const GenericCard = (props: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 58 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" stroke="#E5E7EB" />
    <rect x="8" y="13" width="9" height="7" rx="1.5" fill="#E5E7EB" />
    <rect x="8" y="26" width="20" height="2" rx="1" fill="#E5E7EB" />
    <rect x="30" y="26" width="8" height="2" rx="1" fill="#E5E7EB" />
    <rect x="40" y="26" width="10" height="2" rx="1" fill="#E5E7EB" />
  </svg>
);

export default GenericCard;
